import React from "react";
import { Typography, Divider, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Radar } from "react-chartjs-2";

import {Speed} from '@material-ui/icons'

const data = {
  labels: ["English", "Math", "Physics", "Chemistry", "Biology", "Indonesian"],
  datasets: [
    {
      label: "Average Score of People Getting Accepted",
      data: [90, 96, 94, 86, 88, 88],
      backgroundColor: "rgba(255, 99, 132, 0.2)",
      borderColor: "rgb(255, 99, 132)",
      pointBackgroundColor: "rgb(255, 99, 132)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgb(255, 99, 132)",
      pointRadius: 5,
    },
    {
      label: "Your Score",
      data: [95, 98, 92, 90, 82, 88],
      backgroundColor: "rgba(54, 162, 235, 0.2)",
      borderColor: "rgb(54, 162, 235)",
      pointBackgroundColor: "rgb(54, 162, 235)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgb(54, 162, 235)",
      pointRadius: 5,
    },
  ],
};

const options = {
  scales: {
    r: {
      pointLabels: {
        font: {
          size: 18,
        },
      },
      min: 70,
      max: 100,
    },
  },
  plugins: {
    legend: {
      labels: {
        // This more specific font property overrides the global property
        font: {
          size: 16,
        },
      },
    },
  },
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    // height: "82vh",
    // overflowY: "scroll",
    // '&::-webkit-scrollbar': {
    //   display: "none"
    // },
    padding: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  content:{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems:"center",
  },
  genButton: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
}));

export default function AdvisorTab() {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Typography variant="h4" color="textPrimary" gutterBottom>
        Welcome to AI Advisor
      </Typography>
      <Divider className={classes.divider} />
      <div className={classes.content}>
        <Button startIcon={<Speed />} variant="contained" color="primary" className={classes.genButton}>Generate Chart</Button>
        <Radar data={data} options={options} />
        <Radar data={data} options={options} />
        <Radar data={data} options={options} />
      </div>
    </div>
  );
}
